import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c748833"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["layout", "selected"]
const _hoisted_2 = { class: "father" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "mother" }
const _hoisted_5 = { key: 1 }

import { computed, PropType } from 'vue'
import { useViewFamilyStore } from '@/rd/ViewFamilyStore'
import { FamilyRelationshipRole } from '@/rd/ResearchDataModel'
import ParentConnector from './ParentConnector.vue'
import PersonCard from './PersonCard.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'FamilyCard',
  props: {
  familyId: String,
  layout: String as PropType<"small" | "tiny" | "dot">,
  noConnector: Boolean,
  showProfileType: Boolean,
  dimmed: Boolean,
  disabled: Boolean,
  selectMode: Boolean,
  static: Boolean,
  noHover: Boolean,
  selectedId: String,
},
  emits: [
  'click',
  'update:selectedId',
],
  setup(__props, { emit }) {

const props = __props;





const viewFamilyStore = useViewFamilyStore()

const layoutRef = computed(() => props.layout ?? 'small')

const viewFamilyRef = computed(() => viewFamilyStore.getAsyncFamily(props.familyId)?.data)
// NOTE: if we have a valid family id but can't see the family, use fake father and mother ids, so they will appear
// as valid but not visible, instead of empty
const fatherIdRef = computed(() => props.familyId ? (viewFamilyRef.value ? viewFamilyRef.value.fatherId : '000-000') : undefined)
const motherIdRef = computed(() => props.familyId ? (viewFamilyRef.value ? viewFamilyRef.value.motherId : '000-000') : undefined)

// person-card for each spouse must be bound to a selected person id, but family card selection represents 
// the whole family, so provide a property the person-card can bind to that is equal to the spouse id if the 
// family is selected

const selectedRef = computed({
  get() { return props.selectMode && props.selectedId == props.familyId },
  set(newValue) { emit('update:selectedId', newValue ? props.familyId : undefined) }
})

const selectedFatherIdRef = computed({
  get() { return selectedRef.value ? viewFamilyRef.value?.fatherId : undefined },
  set(newValue) { selectedRef.value = !!newValue }
})

const selectedMotherIdRef = computed({
  get() { return selectedRef.value ? viewFamilyRef.value?.motherId : undefined },
  set(newValue) { selectedRef.value = !!newValue }
})

function onSelected(spouseRole: FamilyRelationshipRole) {
  emit('click', spouseRole)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["family-card", { dimmed: props.dimmed }]),
    layout: layoutRef.value,
    selected: selectedRef.value
  }, [
    _createElementVNode("div", _hoisted_2, [
      (!props.noConnector)
        ? (_openBlock(), _createBlock(ParentConnector, {
            key: 0,
            layout: layoutRef.value,
            dimmed: props.dimmed
          }, null, 8, ["layout", "dimmed"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_3)),
      _createVNode(PersonCard, {
        personId: fatherIdRef.value,
        layout: layoutRef.value,
        "show-profile-type": props.showProfileType,
        "show-profile-count": "multiple",
        "select-mode": __props.selectMode,
        static: props.static,
        "no-hover": __props.noHover,
        selectedId: selectedFatherIdRef.value,
        "onUpdate:selectedId": _cache[0] || (_cache[0] = ($event: any) => ((selectedFatherIdRef).value = $event)),
        disabled: __props.disabled,
        onClick: _cache[1] || (_cache[1] = ($event: any) => (onSelected(_unref(FamilyRelationshipRole).Father)))
      }, null, 8, ["personId", "layout", "show-profile-type", "select-mode", "static", "no-hover", "selectedId", "disabled"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      (!props.noConnector)
        ? (_openBlock(), _createBlock(ParentConnector, {
            key: 0,
            layout: layoutRef.value,
            dimmed: props.dimmed,
            mother: ""
          }, null, 8, ["layout", "dimmed"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_5)),
      _createVNode(PersonCard, {
        personId: motherIdRef.value,
        layout: layoutRef.value,
        "show-profile-type": __props.showProfileType,
        "show-profile-count": "multiple",
        "select-mode": __props.selectMode,
        static: props.static,
        "no-hover": __props.noHover,
        selectedId: selectedMotherIdRef.value,
        "onUpdate:selectedId": _cache[2] || (_cache[2] = ($event: any) => ((selectedMotherIdRef).value = $event)),
        disabled: __props.disabled,
        onClick: _cache[3] || (_cache[3] = ($event: any) => (onSelected(_unref(FamilyRelationshipRole).Mother)))
      }, null, 8, ["personId", "layout", "show-profile-type", "select-mode", "static", "no-hover", "selectedId", "disabled"])
    ])
  ], 10, _hoisted_1))
}
}

})